import withAuth from '../../../wrappers/auth';
import { useXProps } from '../../../hooks/useXProps';
import { TabSelector } from '../TabSelector';
import ImportLocationsModal from '../../modals/ImportLocationsModal';
import FileList from '../../molecules/FileList/FileList';
import { FileUploadProvider } from '../../../context/LocationUploadContext';

const Home = () => {
  let { canViewLocationsOnboardingFiles } = useXProps();
  canViewLocationsOnboardingFiles =
    canViewLocationsOnboardingFiles ||
    window.sessionStorage.getItem('canViewLocationsOnboardingFiles') === 'true';

  return (
    <FileUploadProvider>
      <div className='h-screen p-8 bg-gray-lighter'>
        <h1 className='text-3xl font-bold'>Locations Onboarding Tool</h1>
        {canViewLocationsOnboardingFiles ? (
          <TabSelector
            tabHeaders={[{ title: 'Upload CSV' }, { title: 'CSV Logs' }]}
          >
            <ImportLocationsModal />
            <FileList />
          </TabSelector>
        ) : (
          <div className='py-10 h-full'>
            <ImportLocationsModal />
          </div>
        )}
      </div>
    </FileUploadProvider>
  );
};

export default withAuth(Home);
